<template>
	<el-dialog :visible.sync="dialogVisible" width="90%" :before-close="handleClose">

		<div class="father_view">
			<div class="tableView">
				<div class="table_list">
					<span style="line-height: 32px">姓名:</span>
					<el-input v-model="select.selectName" @clear="getseconduser" placeholder="请输入姓名" :clearable="true"
						style="margin-left: 10px;width: 150px;"></el-input>
				</div>
				<div class="table_list">
					<span style="line-height: 32px;margin-left: 20px;">手机号:</span>
					<el-input v-model="select.selectPhone" @clear="getseconduser" type="number" oninput="if(value.length>11) value = value.slice(0,11)" placeholder="请输入手机号" :clearable="true"
						style="margin-left: 10px;width: 150px;"></el-input>
				</div>
				<div class="table_list">
					<span style="line-height: 32px;margin-left: 20px;">状态:</span>
					<el-select v-model="select.selectValue1" @clear="getseconduser" clearable placeholder="请选择"
						style="width: 120px;margin-left: 10px;">
						<el-option v-for="(item, index) in select.options1" :key="index" :label="item.text"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="table_list">
					<span style="line-height: 32px;margin-left: 20px;">是否申报:</span>
					<el-select v-model="select.selectValue2" @clear="getseconduser" clearable placeholder="请选择"
						style="width: 120px;margin-left: 10px;">
						<el-option v-for="(item, index) in select.options2" :key="index" :label="item.text"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="table_list">
					<span style="line-height: 32px;margin-left: 20px;">是否推荐:</span>
					<el-select v-model="select.selectValue3" @clear="getseconduser" clearable placeholder="请选择"
						style="width: 120px;margin-left: 10px;">
						<el-option v-for="(item, index) in select.options3" :key="index" :label="item.text"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="table_list">
					<el-button type="primary" style="margin-left: 20px" @click="searchData">
						查询
					</el-button>
				</div>
			</div>
			<div class="infoBodyTitle">
				<p v-for="(tab,index) in navList" :key="index" @click="showSelect(tab,index)">{{tab}}</p>
			</div>
		</div>


		<!-- 封装表格组件 -->
		<normalTable v-loading="loading" :check="true" @checkbox="checkbox" :tabList="tabList" :tableList="tableList"
			@copol-click="reciveClick"></normalTable>

		<div style="margin-top: 20px;" v-if="totalNum>10">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="totalNum" background>
			</el-pagination>
		</div>

		<innerDialog ref="innerdialog" @refresh="getseconduser"></innerDialog>
		<importDialog ref="importdialog" @reFresh="getseconduser"></importDialog>

	</el-dialog>
</template>
<script>
	import {
		getSecondUser,
		freezeSecond,
		agreeRecommend,
		resetPassword
	} from '../../../api/moudles/application.js'
	import {vaildte} from '../../../utils/validate.js'
	import normalTable from '../../../components/table/normalTable.vue'
	import innerDialog from './innerDialog.vue'
	import importDialog from './importDialog.vue'

	export default {
		data() {
			return {
				select: {
					options1: [{
						text: '全部',
						value: ''
					}, {
						text: '正常',
						value: '1'
					}, {
						text: '冻结',
						value: '0'
					}],
					options2: [{
						text: '全部',
						value: ''
					}, {
						text: '是',
						value: '1'
					}, {
						text: '否',
						value: '0'
					}],
					options3: [{
						text: '全部',
						value: ''
					}, {
						text: '是',
						value: '1'
					}, {
						text: '否',
						value: '0'
					}],
					selectName: '',
					selectPhone: '',
					selectValue1: '',
					selectValue2: '',
					selectValue3: ''
				},
				loading: false,
				dialogVisible: false,
				projectCode: '',
				// 标题列表
				highline: 0,
				navList: ['解冻', '冻结', '添加', '导入', '同意推荐'],
				tabList: ['姓名', '手机号', '状态', '是否申报', '是否推荐', '动作'],
				tableList: [],
				ids: [],
				codeList: [],
				// 分页
				currentPage: 1,
				pageSize: 10,
				totalNum: 0
			}
		},
		components: {
			normalTable,
			innerDialog,
			importDialog
		},
		methods: {
			searchData() {
				if(this.select.selectPhone){
					if(!vaildte.isPhone(this.select.selectPhone)){
						this.$message.error('请输入正确的手机号')
						return
					}
				}
				this.getseconduser()
			},
			// 分页
			handleSizeChange(val) {
				this.pageSize = val
				this.getseconduser()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getseconduser()
			},
			handleClose() {
				this.dialogVisible = false
			},
			async getseconduser(key) {
				const params = {
					name: this.select.selectName,
					cellphone:this.select.selectPhone,
					project_code: key ? key : this.projectCode,
					is_commit: this.select.selectValue2,
					is_recommend: this.select.selectValue3,
					status: this.select.selectValue1,
					page: this.currentPage,
					limit: this.pageSize
				}
				this.loading = true
				await getSecondUser({
					data: params,
					success: (res) => {
						console.log(res)
						this.totalNum = res.totalCount
						let dataList = res.data;
						let upList = []
						let codelist = []
						dataList.forEach((item) => {
							let newlist = {}
							newlist['username'] = item.username
							newlist['cellphone'] = item.cellphone
							newlist['status'] = item.status
							newlist['is_commit'] = item.is_commit
							newlist['is_recommend'] = item.is_recommend
							newlist['socaq'] = ['冻结', '同意推荐', '重置密码']
							if (item.status === '冻结') {
								newlist['socaq'][0] = '解冻'
							}
							codelist.push(item.id)
							upList.push(newlist)
						})
						this.codeList = codelist
						this.tableList = upList
						this.loading = false
					}
				})
			},
			showPay(key) {
				this.dialogVisible = true
				this.projectCode = key
				this.getseconduser(key)
			},
			showSelect(e, index) {
				this.highline = index
				if (e === '添加') {
					this.$refs['innerdialog'].showDialog(this.projectCode)
				} else if (e === '导入') {
					this.$refs['importdialog'].showDialog(this.projectCode)
				} else if (e === '解冻') {
					this.isFreezeMore(false)
				} else if (e === '冻结') {
					this.isFreezeMore(true)
				} else if (e === '同意推荐') {
					this.agreeRecomdMore()
				}
			},
			// 批量解冻冻结
			isFreezeMore(kind) {
				if (kind && this.ids.length) {
					// 冻结
					freezeSecond({
						data: {
							type: 0,
							ids: this.ids
						},
						success: (res) => {
							console.log(res)
							if (res.code === 200) {
								this.$message({
									message: res.msg,
									type: 'success'
								});
								this.getseconduser()
							} else {
								this.$message.error(res.msg)
							}
						}
					})
				} else if (!kind && this.ids.length) {
					//解冻
					freezeSecond({
						data: {
							type: 1,
							ids: this.ids
						},
						success: (res) => {
							console.log(res)
							if (res.code === 200) {
								this.$message({
									message: res.msg,
									type: 'success'
								});
								this.getseconduser()
							} else {
								this.$message.error(res.msg)
							}
						}
					})
				} else {
					this.$message.error('请先选中数据')
				}
			},
			// 冻结解冻
			isFreeze(e) {
				const {
					item,
					key
				} = e
				if (item.status === '正常' && !this.ids.length) {
					// 冻结
					freezeSecond({
						data: {
							type: 0,
							ids: this.codeList[key]
						},
						success: (res) => {
							console.log(res)
							if (res.code === 200) {
								this.$message({
									message: res.msg,
									type: 'success'
								});
								this.getseconduser()
							} else {
								this.$message.error(res.msg)
							}
						}
					})
				} else if (item.status === '冻结' && !this.ids.length) {
					//解冻
					freezeSecond({
						data: {
							type: 1,
							ids: this.codeList[key]
						},
						success: (res) => {
							console.log(res)
							if (res.code === 200) {
								this.$message({
									message: res.msg,
									type: 'success'
								});
								this.getseconduser()
							} else {
								this.$message.error(res.msg)
							}
						}
					})
				} else {
					this.$message.error('请选中后使用批量操作')
				}
			},

			// 批量同意推荐
			agreeRecomdMore() {
				if (!this.ids.length) {
					this.$message.error('请先选中数据')
					return
				}
				agreeRecommend({
					data: {
						ids: this.ids
					},
					success: (res) => {
						if (res.code === 200) {
							this.$message({
								message: res.msg,
								type: 'success'
							});
							this.getseconduser()
						} else {
							this.$message.error(res.msg)
						}
					}
				})
			},
			// 同意推荐
			agreeRecomd(e) {
				const {
					key,
					item
				} = e
				if (this.ids.length) {
					this.$message.error('请选中后使用批量操作')
					return
				}
				if (item.is_commit === '否') {
					this.$message.error('没有申报，不可推荐')
					return
				}
				agreeRecommend({
					data: {
						ids: this.codeList[key]
					},
					success: (res) => {
						if (res.code === 200) {
							this.$message({
								message: res.msg,
								type: 'success'
							});
							this.getseconduser()
						} else {
							this.$message.error(res.msg)
						}
					}
				})
			},
			// 重置密码
			resetpassword(e) {
				console.log(e)
				const {
					key
				} = e
				resetPassword({
					data: {
						id: this.codeList[key]
					},
					success: (res) => {
						if (res.code === 200) {
							this.$message({
								message: res.msg,
								type: 'success'
							});
							this.getseconduser()
						} else {
							this.$message.error(res.msg)
						}
					}
				})
			},
			// 列表动作监听
			reciveClick(e) {
				const {
					list
				} = e
				if (list === '冻结' || list === '解冻') {
					this.isFreeze(e)
				} else if (list === '同意推荐') {
					this.agreeRecomd(e)
					// this.$router.push('/applyinvoice')
				} else if (list === '重置密码') {
					this.resetpassword(e)
				}
			},
			// 监听复选框
			checkbox(e) {
				let newArray = []
				e.forEach((item, index) => {
					if (item) {
						newArray.push(this.codeList[index])
					}
				})
				this.ids = newArray
			}
		}
	}
</script>

<style scoped="scoped">
	.infoBodyTitle {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		/* margin-bottom: 20px; */
	}

	.infoBodyTitle p {
		display: inline-block;
		width: 90px;
		height: 40px;
		line-height: 40px;
		border: 1px solid #DBDBDB;
		box-sizing: border-box;
		cursor: pointer;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #666666;
	}

	.infoBodyTitle p:hover {
		background: #158AED;
		color: white !important;
		border: none !important;
	}
	
	/* 取消element ui input基础样式 */
	>>>input::-webkit-outer-spin-button,
	>>>input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}
	
	>>>input[type="number"] {
		-moz-appearance: textfield;
	}
	
	.father_view{
		display: flex;
		/* margin: 20px 0; */
		align-items: center; 
		justify-content: space-between;
	}
	.tableView {
		display: flex;
		margin: 20px 0;
		flex-wrap: wrap;
	}
	.table_list{
		margin-bottom: 10px;
	}
</style>
